import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { first } from 'rxjs/operators';
import { Usuario } from '@/Interfaces';
import {  AutenticacionService ,UsuarioService} from '@/Servicios';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @Output() actNombreModulo: EventEmitter<string[]> = new EventEmitter();
  @Output() ruta: EventEmitter<string> = new EventEmitter();

  currentUser: Usuario;
  users = [];
  IdUsuario = 0;
  constructor(
       private authenticationService ?: AutenticacionService,
       private userService ?: UsuarioService,
       private SpinnerService ?:NgxSpinnerService
  ) {
    this.SpinnerService.hide();
      this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
      //this.loadAllUsers();
  }

  /* deleteUser(id: number) {
      this.userService.delete(id)
          .pipe(first())
          .subscribe(() => this.loadAllUsers());
  } */

/*   private loadAllUsers() {
  } */

  
}
